<ng-content select="ngu-accordion-header"></ng-content>
<div #child [@bodyExpansion]="{value: panelState[0]}" class="child">
  <ng-content></ng-content>
</div>
